// LinkSubstringHashtag.js
'use strict';
import { connect } from 'react-redux';

import LinkSubstringHashtag from '../component/LinkSubstringHashtag.jsx';
import { searchType } from '../resource/searchConstants.js';
import getRouteHistory from '../selector/getRouteHistory.js';

const mapStateToProps = state => {
  const currentRoute = getRouteHistory(state, 'currentRoute') || '';
  const via = currentRoute.startsWith('/flix/')
    ? searchType.FLIX
    : currentRoute.startsWith('/story/') || currentRoute.startsWith('/message/')
      ? searchType.STORY
      : searchType.FLIX;

  return {
    via,
  };
};

export default connect(mapStateToProps, null)(LinkSubstringHashtag);
